import { actionCreatorFactory } from "typescript-fsa";
import {
    AuthProvider, AuthSecrets, AuthSettings, ConnectionKind, KeycloakField, LdapField,
    ProvisionRole, TestResult,
} from "../typing/generalType";

const actionCreator = actionCreatorFactory("AuthSettings");

/** The hub answered GET or a save went through: this is now the stored state. */
const settingsLoaded = actionCreator<{ settings: AuthSettings }>("AUTHSETTINGS_LOADED");
const loadFailed = actionCreator<{}>("AUTHSETTINGS_LOAD_FAILED");
const setProviders = actionCreator<{ providers: readonly AuthProvider[] }>("AUTHSETTINGS_SET_PROVIDERS");
const setProvisionRole = actionCreator<{ role: ProvisionRole }>("AUTHSETTINGS_SET_PROVISION_ROLE");
const setLdapField = actionCreator<{ field: LdapField; value: string | number | boolean | null }>("AUTHSETTINGS_SET_LDAP_FIELD");
const setKeycloakField = actionCreator<{ field: KeycloakField; value: string | boolean }>("AUTHSETTINGS_SET_KEYCLOAK_FIELD");
const setSecret = actionCreator<{ field: keyof AuthSecrets; value: string }>("AUTHSETTINGS_SET_SECRET");
const saveStarted = actionCreator<{}>("AUTHSETTINGS_SAVE_STARTED");
const saveRefused = actionCreator<{ errors: readonly string[] }>("AUTHSETTINGS_SAVE_REFUSED");
const setTestResult = actionCreator<{ kind: ConnectionKind; result: TestResult }>("AUTHSETTINGS_SET_TEST_RESULT");

export const actions = {
    settingsLoaded, loadFailed, setProviders, setProvisionRole, setLdapField,
    setKeycloakField, setSecret, saveStarted, saveRefused, setTestResult,
};
